export enum PersonalShelf {
  ContinueWatching = 'continue_watching',
  Favorites = 'favorites',
}

export const PersonalShelves = [PersonalShelf.Favorites, PersonalShelf.ContinueWatching];

export const INTEGRATION = {
  JWP: 'JWP',
  CLEENG: 'CLEENG',
} as const;

export const ACCESS_MODEL = {
  AVOD: 'AVOD',
  AUTHVOD: 'AUTHVOD',
  SVOD: 'SVOD',
  FREE: 'FREE',
  FREEAUTH: 'FREEAUTH',
} as const;

export const ROLES = {
  SUPERADMIN: 'play_superadmin',
  ADMIN: 'play_admin',
  USER: 'play_user',
} as const;

export const PERMISSIONS = {
  VIEW_CONTENT: 'view:content',
  VIEW_MEDIA: 'view:media',
  CREATE_MEDIA: 'create:media',
  UPDATE_MEDIA: 'update:media',
  DELETE_MEDIA: 'delete:media',
  APPROVALS_MEDIA: 'approvals:media',
  // Broadcast Live specific permissions
  VIEW_BROADCAST_LIVE: 'view:broadcast_live',
  CREATE_BROADCAST_LIVE: 'create:broadcast_live',
  UPDATE_BROADCAST_LIVE: 'update:broadcast_live',
  DELETE_BROADCAST_LIVE: 'delete:broadcast_live',
} as const;

export type Permission = typeof PERMISSIONS[keyof typeof PERMISSIONS];

export const hasPermission = (user: { permissions?: string[] } | null | undefined, permission: Permission): boolean => {
  return !!user?.permissions?.includes(permission);
};


export const VideoProgressMinMax = {
  Min: 0.000000000000001,
  Max: 0.999999999999999,
};

export const PLAYLIST_LIMIT = 25;
export const PLAYLIST_INIT_OFFSET = 1;

export const ADYEN_TEST_CLIENT_KEY = 'test_I4OFGUUCEVB5TI222AS3N2Y2LY6PJM3K';

export const ADYEN_LIVE_CLIENT_KEY = 'live_BQDOFBYTGZB3XKF62GBYSLPUJ4YW2TPL';

// how often the live channel schedule is refetched in ms
export const LIVE_CHANNELS_REFETCH_INTERVAL = 15 * 60_000;

// Some predefined types of JW
export const CONTENT_TYPE = {
  // Series page with seasons / episodes
  series: 'series',
  // Separate episode page
  episode: 'episode',
  // Page with a list of channels
  live: 'live',
  // Separate channel page
  liveChannel: 'livechannel',
  // Static page with markdown
  page: 'page',
  // Page with shelves list
  hub: 'hub',
} as const;

// OTT shared player
export const OTT_GLOBAL_PLAYER_ID = 'M4qoGvUk';

export const CONFIG_QUERY_KEY = 'app-config';

export const CONFIG_FILE_STORAGE_KEY = 'config-file-override';

export const CACHE_TIME = 60 * 1000 * 20; // 20 minutes

export const STALE_TIME = 60 * 1000 * 20;

export const CARD_ASPECT_RATIOS = ['1:1', '2:1', '2:3', '4:3', '5:3', '16:9', '9:13', '9:16'] as const;

export const MAX_WATCHLIST_ITEMS_COUNT = 48; // Default value

export const DEFAULT_FEATURES = {
  canUpdateEmail: false,
  canSupportEmptyFullName: false,
  canChangePasswordWithOldPassword: false,
  canRenewSubscription: false,
  canExportAccountData: false,
  canDeleteAccount: false,
  canUpdatePaymentMethod: false,
  canShowReceipts: false,
  hasSocialURLs: false,
  hasNotifications: false,
  watchListSizeLimit: MAX_WATCHLIST_ITEMS_COUNT,
};

export const simultaneousLoginWarningKey = 'simultaneous_logins';

export const EPG_TYPE = {
  jwp: 'jwp',
  viewNexa: 'viewnexa',
} as const;

export const APP_CONFIG_ITEM_TYPE = {
  playlist: 'playlist',
  continue_watching: 'continue_watching',
  favorites: 'favorites',
  content_list: 'content_list',
  media: 'media',
} as const;

export const MANIFEST_TYPE = {
  dash: 'application/dash+xml"',
  hls: 'application/vnd.apple.mpegurl',
};

export const S73_CDN_PATH = 'https://cdn.s73cloud.com/4/s73-sdk-jwplayer.js';
